module.exports = __webpack_public_path__ + "static/media/SDFSA_7-509w.5cbe78c6.jpg";